

export const AppName = () => <span style={{fontWeight:'bolder'}}>PenKitSearch.com</span>